import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconMenu = _resolveComponent("IconMenu")!
  const _component_PropertyValue = _resolveComponent("PropertyValue")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_ctx.location && _ctx.locationProperties)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.groupedBySectionViewOrder), ([sectionViewOrder, items]) => {
          return (_openBlock(), _createElementBlock("div", { key: sectionViewOrder }, [
            _createElementVNode("div", null, [
              (items[0].sectionViewSize > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (items[0].sectionViewSize > 0)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(items[0].sectionTitle), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (items.some((item) => item.rangeColor != null))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['tbdc-grid', 'tbdc-property-' + item.name]),
                        key: item.name
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["tbdc-row", { 'is-disabled': _ctx.isDisabled(item.poiSetName) }])
                        }, [
                          _createVNode(_component_v_tooltip, {
                            location: "bottom",
                            disabled: item.description == null,
                            "open-delay": "250",
                            "open-on-hover": true
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_IconMenu, {
                                showMenu: _ctx.showIconMenu,
                                menuName: item.name,
                                menuTitle: item.title,
                                items: [_ctx.poiToIconItem(item), _ctx.propertyToIconItem(item)]
                              }, {
                                header: _withCtx(() => [
                                  _createElementVNode("span", _mergeProps({ ref_for: true }, props, {
                                    innerHTML: _ctx.convertMdiBracketToIcon(item.title)
                                  }), null, 16, _hoisted_5)
                                ]),
                                _: 2
                              }, 1032, ["showMenu", "menuName", "menuTitle", "items"]),
                              _createElementVNode("div", _mergeProps({ ref_for: true }, props, { style: {"text-align":"right"} }), [
                                _createVNode(_component_PropertyValue, {
                                  onlyImpact: false,
                                  property: item,
                                  output: item.propertyType == 4,
                                  currency: _ctx.model.currency
                                }, null, 8, ["property", "output", "currency"])
                              ], 16),
                              _createElementVNode("div", _mergeProps({ ref_for: true }, props, { style: {"text-align":"right"} }), [
                                _createVNode(_component_PropertyValue, {
                                  onlyImpact: true,
                                  property: item,
                                  output: item.propertyType == 4,
                                  currency: _ctx.model.currency
                                }, null, 8, ["property", "output", "currency"])
                              ], 16)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.description), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"])
                        ], 2)
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(['tbdc-grid', 'tbdc-property-' + item.name]),
                      key: item.name
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tbdc-row", { 'is-disabled': _ctx.isDisabled(item.poiSetName) }])
                      }, [
                        _createVNode(_component_v_tooltip, {
                          location: "bottom",
                          disabled: item.description == null,
                          "open-delay": "250",
                          "open-on-hover": true
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_IconMenu, {
                              showMenu: _ctx.showIconMenu,
                              menuName: item.name,
                              menuTitle: item.title,
                              items: [_ctx.poiToIconItem(item), _ctx.propertyToIconItem(item)]
                            }, {
                              header: _withCtx(() => [
                                _createElementVNode("span", _mergeProps({ ref_for: true }, props, {
                                  innerHTML: _ctx.convertMdiBracketToIcon(item.title)
                                }), null, 16, _hoisted_6)
                              ]),
                              _: 2
                            }, 1032, ["showMenu", "menuName", "menuTitle", "items"]),
                            _createElementVNode("div", _mergeProps({ ref_for: true }, props, { style: {"text-align":"right"} }), [
                              _createVNode(_component_PropertyValue, {
                                onlyImpact: false,
                                property: item,
                                output: item.propertyType == 4,
                                currency: _ctx.model.currency
                              }, null, 8, ["property", "output", "currency"])
                            ], 16),
                            _createElementVNode("div", _mergeProps({ ref_for: true }, props, { style: {"text-align":"right"} }), [
                              _createVNode(_component_PropertyValue, {
                                onlyImpact: true,
                                property: item,
                                output: item.propertyType == 4,
                                currency: _ctx.model.currency
                              }, null, 8, ["property", "output", "currency"])
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(item.description), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"])
                      ], 2)
                    ], 2))
                  }), 128))
            ]),
            _createVNode(_component_v_spacer, { class: "mb-1 mt-3" })
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}